import { FetchResult, MutationResult, useMutation } from '@apollo/client';
import {
	CreateGroupInput, CreateSpotifyGroupsDocument, CreateSpotifyGroupsMutation, GroupStatus,
} from 'wb-spotify/graphql/generated';
import { SpotifyGroupCreateData } from 'wb-spotify/app/routes/superGrid/mutator/utils';
import {
	getSpotifyGroupVariablesFromSupergridMutation,
} from 'wb-spotify/app/routes/superGrid/mutator/hooks/utils';

const useCreateSpotifyGroups = (): [
	((
		groupsInCreation: SpotifyGroupCreateData[],
		status: GroupStatus
	) => Promise<FetchResult<CreateSpotifyGroupsMutation>>),
	MutationResult<CreateSpotifyGroupsMutation>,
] => {
	const [createSpotifyGroups, result] = useMutation(CreateSpotifyGroupsDocument, {
		errorPolicy: 'all',
	});

	async function onCreateSpotifyGroups(
		groupsInCreation: SpotifyGroupCreateData[],
		status: GroupStatus,
	) {
		const groups: CreateGroupInput[] = groupsInCreation.map((group) => getSpotifyGroupVariablesFromSupergridMutation(group, status));

		return createSpotifyGroups({
			variables: { groups },
		});
	}

	return [
		onCreateSpotifyGroups,
		result,
	];
};

export default useCreateSpotifyGroups;
